// config/stripe.ts - Configuration Stripe centralisée
// À placer dans src/config/stripe.ts
//
// Toutes les valeurs viennent de process.env.REACT_APP_* (définies dans
// .env.development / .env.production). react-scripts les injecte au moment
// du `npm run build` — le build Capacitor utilisant ce même dossier `build/`
// (webDir), il n'y a pas besoin d'une configuration séparée codée en dur
// pour l'app Android : elle recevrait les mêmes variables que la version web.

export const stripeConfig = {
  // Clé publique Stripe (non secrète par nature, mais on évite de la coder
  // en dur pour ne pas avoir deux sources de vérité qui divergent).
  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',

  prices: {
    monthly: process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID || '',
    yearly: process.env.REACT_APP_STRIPE_YEARLY_PRICE_ID || ''
  },

  apiUrl: process.env.REACT_APP_API_URL || 'https://jogolinga-backend-production.up.railway.app'
};

// ✅ Fonction de validation
export const validateStripeConfig = (): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  if (!stripeConfig.publishableKey) {
    errors.push('❌ REACT_APP_STRIPE_PUBLISHABLE_KEY manquant');
  }

  if (!stripeConfig.prices.monthly) {
    errors.push('❌ REACT_APP_STRIPE_MONTHLY_PRICE_ID manquant');
  }

  if (!stripeConfig.prices.yearly) {
    errors.push('❌ REACT_APP_STRIPE_YEARLY_PRICE_ID manquant');
  }

  if (!stripeConfig.apiUrl) {
    errors.push('❌ REACT_APP_API_URL manquant');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

// ✅ Log de debug au démarrage
const validation = validateStripeConfig();


if (!validation.isValid) {} else {

}

export default stripeConfig;